import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    background: #0a0a0a;
    color: #ffffff;
    line-height: 1.6;
  }
`;

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #00d4ff, #ff00ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Button = styled.button`
  background: linear-gradient(135deg, #00d4ff, #ff00ff);
  border: none;
  color: white;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

export const List = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
`;

export const ListItem = styled.div<{ found?: boolean }>`
  padding: 0.75rem;
  margin: 0.5rem 0;
  background: ${props => props.found ? 'rgba(0, 255, 0, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 8px;
  color: ${props => props.found ? '#ffffff' : '#cccccc'};
`;

export const Input = styled.input<{ error?: boolean; success?: boolean }>`
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid ${props => props.error ? '#ff0000' : props.success ? '#00ff00' : 'rgba(255, 255, 255, 0.2)'};
  border-radius: 12px;
  color: white;
  margin-bottom: 1rem;
  transition: border-color 0.3s;
  
  &:focus {
    outline: none;
    border-color: #00d4ff;
  }
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const StatCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 0.5rem;
  border-radius: 8px;
`;

export const StatTitle = styled.h3`
  font-size: 0.8rem;
  color: #00d4ff;
  margin-bottom: 0.25rem;
`;

export const GuessedList = styled.div`
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.9rem;
`;

export const Timer = styled.div`
  text-align: center;
  font-size: 1.5rem;
  color: #00d4ff;
  margin-bottom: 1rem;
`;

export const CompletionMessage = styled.div`
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.2), rgba(255, 0, 255, 0.2));
  border-radius: 12px;
  margin-bottom: 2rem;
  
  h2 {
    color: #00ff00;
    margin-bottom: 1rem;
  }
`;

export const RegionHeader = styled.h2`
  font-size: 1.5rem;
  color: #00d4ff;
  margin: 2rem 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(0, 212, 255, 0.3);
  
  span {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.7);
    font-weight: normal;
  }
`;

export const TotalRemaining = styled.div`
  text-align: center;
  font-size: 1.2rem;
  color: #ff00ff;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(255, 0, 255, 0.1);
  border-radius: 8px;
`;

export const CorrectCountiesSection = styled.div`
  margin-bottom: 1rem;
`;

export const SectionHeading = styled.h3`
  font-size: 1.1rem;
  color: #00ff00;
  margin-bottom: 0.5rem;
  text-align: center;
`;
